import axios from "axios";
import { getToken } from "../../config/TokenHelper";
export const AdminLogin = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/adminLogin", data, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createRoomHospitalityService = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/createRoomHospitalityService",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getRoomList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getRoomListAdmin",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getAdminNotificationList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/getNotificationListAdminById",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getRoomFeatureList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/user/getRoomFeatureList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createRoomFeature = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createRoomFeature",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const editRoomFeatures = (roomFeatureId) => {
  console.log(roomFeatureId);
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/user/returnRoomFeatureById",
      { roomFeatureId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log(data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateRoomHospitalityService = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/updateRoomHospitalityService",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log("data", data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeRoomHospitalityService = (roomHospitalityServiceId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/removeRoomHospitalityService",
      { roomHospitalityServiceId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log("data", data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateRoomFeature = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateRoomFeature",
      data,

      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeRoomFeature = (roomFeatureId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeRoomFeature",
      { roomFeatureId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log("data", data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createRoomType = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createRoomType",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getRoomTypeList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getRoomTypeList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const editRoomTypeById = (roomTypeId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/returnRoomTypeById",
      { roomTypeId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log(data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateRoomType = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateRoomType",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeRoomType = (roomTypeId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeRoomType",
      { roomTypeId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log("data", data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createRoom = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createRoom", data, {
      headers: {
        "content-type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeRoom = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeRoom", data, {
      headers: {
        "content-type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      console.log("data", data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getRoomById = (roomId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getRoomById",
      { roomId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getRoomHospitalityServiceList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/getRoomHospitalityServiceList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createAmenityType = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createAmenityType",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getAmenityTypeList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getAmenityTypeList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getroomHospitalityServiceId = (roomHospitalityServiceId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/returnRoomHospitalityServiceById",
      { roomHospitalityServiceId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log(data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateAmenityType = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateAmenityType",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeAmenityType = (amenityTypeId) => {
  console.log(amenityTypeId);
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeAmenityType",
      { amenityTypeId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      console.log(data);
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const editAmenityType = (amenityTypeId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getAmenityTypeById",
      { amenityTypeId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const totalDoctor = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalDoctor",

      {
        headers: {
          authToken: getToken(),
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const totalUser = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalUser",

      {
        headers: {
          authToken: getToken(),
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createFoodCuisine = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createFoodCuisine",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getFoodCuisineList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodCuisineList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getFoodCuisineById = (foodCuisineId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodCuisineById",
      { foodCuisineId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateFoodCuisine = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFoodCuisine",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeFoodCuisine = (foodCuisineId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeFoodCuisine",
      { foodCuisineId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createFood = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createFood", data, {
      headers: {
        "content-type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
// page/limit optional - see getUsers.
export const getFoodList = (page, limit) => {
  const qs = page ? `?page=${page}&limit=${limit || 25}` : "";
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodListAdmin" + qs,

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getFoodById = (foodId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodById",
      { foodId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateFood = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFood", data, {
      headers: {
        "content-type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createFoodAddOn = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createFoodAddOn",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const getFoodAddOnList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodAddOnList",

      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
export const getFoodAddOnById = (foodAddOnId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodAddOnById",
      { foodAddOnId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateFoodAddOn = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFoodAddOn",
      data,
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
export const removeFoodAddOn = (foodAddOnId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeFoodAddOn",
      { foodAddOnId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const createTable = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createTable", data, {
      headers: {
        "content-type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
export const getTableList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getTableList",

      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const gettableId = (tableId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/gettableId",
      { tableId },
      {
        headers: {
          "content-type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
export const removetable = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removetable", data, {
      headers: {
        "content-type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateTable = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateTable", data, {
      headers: {
        "content-type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//
export const addAttraction = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createAttraction",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
//

export const attractionList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getAttractionList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};
export const editAttraction = (attractionId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getattractionById",
      { attractionId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};
export const removeAttraction = (attractionId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeAttraction",
      { attractionId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const updateAttraction = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateAttraction",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeFood = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeFood", data, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const deleteFood = (foodId) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/deleteFood", { foodId }, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return null;
    });
};

//taxi
export const createTaxi = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createTaxi", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateTaxi = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateTaxi", data, {
      headers: {
        "Content-Type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//getlistById
export const getTaxiById = (taxiId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getTaxiById",
      { taxiId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};
//

export const removeTaxi = (taxiId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeTaxi",
      { taxiId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const getTaxiList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getTaxiList",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//SMS Notitication things
// Create SMS Notification
export const createSMSNotification = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/smsNotification",
      data,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating SMS notification:", error);
      return null;
    });
};

// Update SMS Notification
export const updateSMSNotification = (id, data) => {
  return axios
    .put(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/admin/smsNotification/${id}`,
      data,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating SMS notification:", error);
      return null;
    });
};

// Get SMS Notifications
export const getSMSNotifications = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/smsNotification", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching SMS notifications:", error);
      return null;
    });
};

// Delete SMS Notification
export const deleteSMSNotification = (id) => {
  return axios
    .delete(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/admin/smsNotification/${id}`,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting SMS notification:", error);
      return null;
    });
};

// page/limit optional - see getChatListAdmin.
// `period` is periodToParams() output; axios appends it to the query.
export const listroomBookingCancellationRequest = (page, limit, period = {}) => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/listroomBookingCancellationRequest" + (page ? `?page=${page}&limit=${limit || 25}` : ""),

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
        params: period,
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const approveCancellationRequest = (roomBookingId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/approveCancellationRequest",
      { roomBookingId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const disapproveCancellationRequest = (roomBookingId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/admin/disapproveCancellationRequest",
      { roomBookingId },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

// `period` is periodToParams() output; axios appends it to the query.
export const listRoomBookingRequest = (page = 1, limit = 15, search = "", period = {}) => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + `/api/admin/roomBookingList?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
        params: period,
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updatePaymentStatus = (roomBookingId, isPaymentSuccess) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateRoomstatus",
      { roomBookingId, isPaymentSuccess },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

//
export const listofDeliveryBoy = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/listofDeliveryBoy",

      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;

      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const foodOrderList = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/foodOrderList",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const AssignDeliveryBoy = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/AssignDeliveryBoy",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//re
export const ReAssignDeliveryBoy = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/ReAssignDeliveryBoy",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//
export const OrderListbyId = (foodorderId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/OrderListbyId",
      { foodorderId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

//OrderFullfilled - API - OrderFullfilled
export const OrderFullfilled = (foodorderId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/OrderFullfilled",
      { foodorderId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

//Notification
export const createNotification = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createNotification",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

export const getNotificationAdmin = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getNotificationAdmin",
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

//DeliveryBoy management
export const addFoodDeliveryBoy = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/addFoodDeliveryBoy",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const getFoodDeliveryBoyList = () => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodDeliveryBoyList",
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const getFoodDeliveryBoyById = (dBoyId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodDeliveryBoyById",
      { dBoyId },

      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const updateFoodDeliveryBoy = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFoodDeliveryBoy",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const removeFoodDeliveryBoy = (dBoyId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeFoodDeliveryBoy",
      { dBoyId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//
export const getUserList = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getUserList", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//user management
export const addUser = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/addUser", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const updateUser = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateUser", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// page/limit are OPTIONAL: called with no arguments the endpoint returns the
// full list exactly as before, so nothing that already uses this changes.
export const getUsers = (page, limit, search) => {
  const parts = [];
  if (page) parts.push(`page=${page}`, `limit=${limit || 25}`);
  if (search) parts.push(`search=${encodeURIComponent(search)}`);
  const qs = parts.length ? `?${parts.join("&")}` : "";
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getUsers" + qs, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//chat
// page/limit optional - omitted means the full list, as before.
export const getChatListAdmin = (page, limit) => {
  const qs = page ? `?page=${page}&limit=${limit || 25}` : "";
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getChatListAdmin" + qs, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const sendMessageAdmin = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/sendMessageAdmin",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const closeChat = (chatMasterId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/closeChat",
      { chatMasterId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};
//byId
export const getChatListAdminById = (chatId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getChatListAdminById",
      { chatId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//Dashboard
export const totalUsers = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalUsers", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};
//
export const totalDboy = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalDboy", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const totalOrders = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalOrders", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// Takes periodToParams() output, or a legacy "today" | "month" filter string.
export const getTotalData = (filter) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalData", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params: typeof filter === "string" ? { filter } : filter,
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const totalRoomsBooked = (filter) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalRoomsBooked", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params: { filter }, // pass filter as query parameter
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const totalDeliveries = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/totalDeliveries", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const orderData = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/orderData", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const monthlyOrders = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/monthlyOrders", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// monthlyOrdersTable
export const monthlyOrdersTable = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/monthlyOrdersTable", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//
export const monthlyBookings = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/monthlyBookings", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// monthlyOrdersTransport
export const monthlyOrdersTransport = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/monthlyOrdersTransport", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const updateRoom = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateRoom", data, {
      headers: {
        "content-type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

//amenities
export const createAmenity = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createAmenity",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const removeAmenity = (amenityId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/removeAmenity",
      { amenityId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const getAmenityList = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getAmenityList", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const getAmenityById = (amenityId) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getAmenityById",
      { amenityId },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const updateAmenity = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateAmenity",
      data,
      {
        headers: {
          "content-type": "multipart/form-data",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

// `period` is periodToParams() output.
export const OrderList = (page = 1, limit = 20, search = "", period = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/foodOrderList", {
      params: { page, limit, search, ...period },
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

export const updateFoodPaymentstatus = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFoodPaymentstatus",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// `period` is periodToParams() output; axios appends it to the query.
export const listTableBookingRequest = (page = 1, limit = 15, search = "", period = {}) => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH + `/api/admin/tableOrderList?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
        params: period,
      }
    )
    .then((response) => {
      const { data } = response;
      return data;
    })
    .catch((issu) => {
      console.log("Issu ----> ", issu);
      return null;
    });
};

export const updateTablePaymentStatus = (tableorderId, isPaymentSuccess) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updatetablePaymentstatus",
      { tableorderId, isPaymentSuccess },
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      return null;
    });
};

//
export const updatetablestatus = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updatetablestatus",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

//update food payment
export const updatepaymentstatus = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updatePaymentStatus",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((err) => {
      return null;
    });
};

// Food Setting things
// Create Food Settings
export const createFoodSettings = (data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/createFoodSettings",
      data,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating food settings:", error);
      return null;
    });
};

// Get Food Settings
export const getFoodSettings = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/admin/getFoodSettings", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching food settings:", error);
      return null;
    });
};

// Update Food Settings
export const updateFoodSettings = (data) => {
  return axios
    .put(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/updateFoodSettings",
      data,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating food settings:", error);
      return null;
    });
};

// Delete Food Settings
export const deleteFoodSettings = (id) => {
  return axios
    .delete(
      process.env.REACT_APP_DEFAULTAUTH + "/api/admin/deleteFoodSettings",
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
        data: { id },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting food settings:", error);
      return null;
    });
};

// ============================================
// TEAM MANAGEMENT (ACM) APIs
// ============================================

// Get all team members (optionally scoped to a branch)
export const getTeamMembers = (branchId) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/team/list", {
      params: branchId ? { branchId } : {},
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching team members:", error);
      return null;
    });
};

// Get available modules
export const getAvailableModules = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/team/modules", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching modules:", error);
      return null;
    });
};

// Get team member by ID
export const getTeamMemberById = (id) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/team/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching team member:", error);
      return null;
    });
};

// Create team member
export const createTeamMember = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/team/create", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating team member:", error);
      return null;
    });
};

// Update team member
export const updateTeamMember = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/team/update/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating team member:", error);
      return null;
    });
};

// Update team member permissions
export const updateTeamPermissions = (id, modulePermissions) => {
  return axios
    .put(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/team/permissions/${id}`,
      { modulePermissions },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating permissions:", error);
      return null;
    });
};

// Reset team member password
export const resetTeamMemberPassword = (id, newPassword) => {
  return axios
    .put(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/team/reset-password/${id}`,
      { newPassword },
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error resetting password:", error);
      return null;
    });
};

// Delete team member
export const deleteTeamMember = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/team/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting team member:", error);
      return null;
    });
};

// ============================================
// COUPON MANAGEMENT APIs
// ============================================

// Get all coupons
export const getCouponList = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/coupon/list", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching coupons:", error);
      return null;
    });
};

// Get coupon by ID
export const getCouponById = (id) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/coupon/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching coupon:", error);
      return null;
    });
};

// Create coupon (supports FormData for image upload)
export const createCoupon = (data) => {
  // Check if data is FormData (has image) or plain object
  const isFormData = data instanceof FormData;

  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/coupon/create", data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating coupon:", error);
      return error.response?.data || { status: 500, success: false, message: error.message || "Network error" };
    });
};

// Update coupon (supports FormData for image upload)
export const updateCoupon = (id, data) => {
  // Check if data is FormData (has image) or plain object
  const isFormData = data instanceof FormData;

  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/coupon/update/${id}`, data, {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating coupon:", error);
      return error.response?.data || { status: 500, success: false, message: error.message || "Network error" };
    });
};

// Toggle coupon status
export const toggleCouponStatus = (id) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/coupon/toggle/${id}`, {}, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error toggling coupon:", error);
      return null;
    });
};

// Delete coupon
export const deleteCoupon = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/coupon/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting coupon:", error);
      return null;
    });
};

// Get coupon analytics
export const getCouponAnalytics = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/coupon/analytics", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching coupon analytics:", error);
      return null;
    });
};

// ============================================
// BANNER MANAGEMENT APIs
// ============================================

// Get all banners
export const getBannerList = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/banner/list", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching banners:", error);
      return null;
    });
};

// Get banner by ID
export const getBannerById = (id) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/banner/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching banner:", error);
      return null;
    });
};

// Create banner (with image upload)
export const createBanner = (formData) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/banner/create", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating banner:", error);
      return error.response?.data || { status: 500, success: false, message: error.message || "Network error" };
    });
};

// Update banner (with optional image upload)
export const updateBanner = (id, formData) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/banner/update/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating banner:", error);
      return error.response?.data || { status: 500, success: false, message: error.message || "Network error" };
    });
};

// Toggle banner status
export const toggleBannerStatus = (id) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/banner/toggle/${id}`, {}, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error toggling banner:", error);
      return null;
    });
};

// Reorder banners
export const reorderBanners = (orderedIds) => {
  return axios
    .put(process.env.REACT_APP_DEFAULTAUTH + "/api/banner/reorder", { orderedIds }, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error reordering banners:", error);
      return null;
    });
};

// Delete banner
export const deleteBanner = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/banner/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting banner:", error);
      return null;
    });
};

// Get banner analytics
export const getBannerAnalytics = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/banner/analytics", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching banner analytics:", error);
      return null;
    });
};

// ============================================
// TRANSPORT MANAGEMENT APIs
// ============================================

// Get transport services (public)
export const getTransportServices = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/services")
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transport services:", error);
      return null;
    });
};

// Calculate transport price
export const calculateTransportPrice = (services) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/calculate-price", { services })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error calculating price:", error);
      return null;
    });
};

// Update transport service (admin)
export const updateTransportService = (code, data) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/services/${code}`, data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating service:", error);
      return null;
    });
};

// Get transport drivers (admin - includes inactive)
export const getTransportDrivers = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/drivers", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching drivers:", error);
      return null;
    });
};

// Get active transport drivers only (for assignment dropdown)
export const getActiveTransportDrivers = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/drivers", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching active drivers:", error);
      return null;
    });
};

// Create transport driver (admin)
export const createTransportDriver = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/drivers", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating driver:", error);
      return null;
    });
};

// Update transport driver (admin)
export const updateTransportDriver = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/drivers/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating driver:", error);
      return error.response?.data || { status: 500, success: false, message: "Network error" };
    });
};

// Delete transport driver (admin)
export const deleteTransportDriver = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/drivers/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting driver:", error);
      return error.response?.data || { status: 500, success: false, message: "Network error" };
    });
};

// Get transport requests (admin)
export const getTransportRequests = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/requests", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching requests:", error);
      return null;
    });
};

// Get transport request by ID (admin)
export const getTransportRequestById = (id) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching request:", error);
      return null;
    });
};

// Accept transport request (admin)
export const acceptTransportRequest = (id) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/accept`, {}, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error accepting request:", error);
      return null;
    });
};

// Reject transport request (admin)
export const rejectTransportRequest = (id, reason) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/reject`, { reason }, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error rejecting request:", error);
      return null;
    });
};

// Assign driver to transport request (admin)
export const assignTransportDriver = (id, driverId, driverDetails) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/assign-driver`,
      { driverId, driverDetails }, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error assigning driver:", error);
      return null;
    });
};

// Update transport request status (admin)
export const updateTransportRequestStatus = (id, status, notes) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/status`,
      { status, notes }, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating status:", error);
      return null;
    });
};

// Cancel transport request (admin)
export const cancelTransportRequest = (id, reason) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/cancel`,
      { reason }, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error cancelling request:", error);
      return null;
    });
};

// Set quote for day rental/outstation request (admin)
export const setTransportQuote = (id, quoteData) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/set-quote`,
      quoteData, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error setting quote:", error);
      return null;
    });
};

// Update transport payment status (admin)
export const updateTransportPaymentStatus = (id, paymentData) => {
  return axios
    .patch(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/requests/${id}/payment`,
      paymentData, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating payment status:", error);
      return null;
    });
};

// Get transport analytics (admin)
export const getTransportAnalytics = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/analytics", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching analytics:", error);
      return null;
    });
};

// ============================================
// VEHICLE TYPE MANAGEMENT APIs
// ============================================

// Get vehicle types (public)
export const getVehicleTypes = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/vehicle-types")
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching vehicle types:", error);
      return null;
    });
};

// Get vehicle types (admin - includes inactive)
export const getVehicleTypesAdmin = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/vehicle-types", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching vehicle types:", error);
      return null;
    });
};

// Create vehicle type (admin)
export const createVehicleType = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/vehicle-types", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating vehicle type:", error);
      return error.response?.data || null;
    });
};

// Update vehicle type (admin)
export const updateVehicleType = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/vehicle-types/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating vehicle type:", error);
      return error.response?.data || null;
    });
};

// Delete vehicle type (admin)
export const deleteVehicleType = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/vehicle-types/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting vehicle type:", error);
      return null;
    });
};

// ============================================
// TRANSPORT SETTINGS APIs
// ============================================

// Get transport settings (admin)
export const getTransportSettings = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/settings", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transport settings:", error);
      return null;
    });
};

// Update transport settings (admin)
export const updateTransportSettings = (data) => {
  return axios
    .put(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/settings", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating transport settings:", error);
      return error.response?.data || null;
    });
};

// ============================================
// TRANSPORT SERVICES APIs (Admin)
// ============================================

// Get transport services (admin - includes all services)
export const getTransportServicesAdmin = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/services", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transport services:", error);
      return null;
    });
};

// ============================================
// ACTIVITY LOGS APIs
// ============================================

// Get activity logs with filters
export const getActivityLogs = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/activity-logs", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching activity logs:", error);
      return null;
    });
};

// Get activity log by ID
export const getActivityLogById = (id) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/activity-logs/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching activity log:", error);
      return null;
    });
};

// Get activity logs by entity
export const getActivityLogsByEntity = (type, id, params = {}) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/activity-logs/entity/${type}/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching entity logs:", error);
      return null;
    });
};

// Get activity logs by user
export const getActivityLogsByUser = (userId, params = {}) => {
  return axios
    .get(`${process.env.REACT_APP_DEFAULTAUTH}/api/activity-logs/user/${userId}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching user logs:", error);
      return null;
    });
};

// Get activity log statistics
export const getActivityLogStats = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/activity-logs/stats", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching log stats:", error);
      return null;
    });
};

// Get activity log filter options
export const getActivityLogFilters = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/activity-logs/filters", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching filter options:", error);
      return null;
    });
};

// ============================================
// ANALYTICS APIs
// ============================================

// Get dashboard summary
// Takes periodToParams() output, or a legacy "week" | "month" | "year" string.
export const getDashboardAnalytics = (period = "month") => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/dashboard", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params: typeof period === "string" ? { period } : period,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching dashboard analytics:", error);
      return null;
    });
};

// Get revenue report
export const getRevenueReport = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/revenue", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching revenue report:", error);
      return null;
    });
};

// Get revenue trends
// Takes periodToParams() output, or a legacy "week" | "month" | "year" string.
export const getRevenueTrends = (period = "month") => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/revenue/trends", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params: typeof period === "string" ? { period } : period,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching revenue trends:", error);
      return null;
    });
};

// Get food analytics
export const getFoodAnalytics = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/food", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching food analytics:", error);
      return null;
    });
};

// Get room analytics
export const getRoomAnalytics = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/room", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching room analytics:", error);
      return null;
    });
};

// Get table analytics
export const getTableAnalytics = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/table", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching table analytics:", error);
      return null;
    });
};

// Get transport analytics (full report)
export const getTransportAnalyticsReport = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/transport", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transport analytics:", error);
      return null;
    });
};

// Get coupon analytics (full report)
export const getCouponAnalyticsReport = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/coupon", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching coupon analytics:", error);
      return null;
    });
};

// Get user analytics
export const getUserAnalytics = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/users", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching user analytics:", error);
      return null;
    });
};

// Export analytics reports
export const exportDashboardAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/dashboard", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting dashboard:", error);
      return null;
    });
};

export const exportRevenueAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/revenue", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting revenue:", error);
      return null;
    });
};

export const exportFoodAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/food", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting food analytics:", error);
      return null;
    });
};

export const exportRoomAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/room", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting room analytics:", error);
      return null;
    });
};

export const exportTableAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/table", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting table analytics:", error);
      return null;
    });
};

export const exportTransportAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/transport", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting transport analytics:", error);
      return null;
    });
};

export const exportCouponAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/coupon", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting coupon analytics:", error);
      return null;
    });
};

export const exportUserAnalytics = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/export/users", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error exporting user analytics:", error);
      return null;
    });
};

// ============================================
// SERVICE TIER MANAGEMENT APIs
// ============================================

// Get service tiers (admin - includes inactive)
export const getServiceTiersAdmin = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/service-tiers", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching service tiers:", error);
      return null;
    });
};

// Create service tier (admin)
export const createServiceTier = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/transport/admin/service-tiers", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating service tier:", error);
      return error.response?.data || null;
    });
};

// Update service tier (admin)
export const updateServiceTier = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/service-tiers/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating service tier:", error);
      return error.response?.data || null;
    });
};

// Delete service tier (admin)
export const deleteServiceTier = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/service-tiers/${id}`, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting service tier:", error);
      return null;
    });
};

// Toggle service tier status (admin)
export const toggleServiceTier = (id) => {
  return axios
    .put(`${process.env.REACT_APP_DEFAULTAUTH}/api/transport/admin/service-tiers/${id}/toggle`, {}, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error toggling service tier:", error);
      return null;
    });
};

// ============ APP VERSION SETTINGS ============
export const getAppVersionSettings = (platform = "android") => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH +
        `/api/user/checkAppVersion?platform=${platform}`,
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching app version settings:", error);
      return null;
    });
};

export const updateAppVersionSettings = (data) => {
  return axios
    .put(
      process.env.REACT_APP_DEFAULTAUTH + "/api/user/appVersionSettings",
      data,
      {
        headers: {
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating app version settings:", error);
      return null;
    });
};

// ============================================
// LOYALTY PROGRAM APIs (Admin)
// ============================================

// Get loyalty program config (global + per-order-type earn/redeem + expiry)
export const getLoyaltyConfig = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/loyalty/config", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching loyalty config:", error);
      return null;
    });
};

// Update loyalty program config
export const updateLoyaltyConfig = (data) => {
  return axios
    .put(process.env.REACT_APP_DEFAULTAUTH + "/api/loyalty/config", data, {
      headers: {
        "Content-Type": "application/json",
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating loyalty config:", error);
      return error.response?.data || null;
    });
};

// List loyalty accounts (paginated; params: page, limit)
export const getLoyaltyAccounts = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/loyalty/accounts", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching loyalty accounts:", error);
      return null;
    });
};

// Get one customer's loyalty balance + ledger history
export const getUserLoyalty = (userId) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/loyalty/accounts/" + userId, {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching user loyalty:", error);
      return null;
    });
};

// Manually adjust a customer's points (positive or negative). data: { points, note }
export const adjustLoyaltyPoints = (userId, data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/loyalty/accounts/" + userId + "/adjust",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          authToken: getToken().authT,
          authKey: getToken().authk,
        },
      }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error adjusting loyalty points:", error);
      return error.response?.data || null;
    });
};

// ============================================
// PAYMENTS & TRANSACTIONS APIs (Admin)
// ============================================

// List M-PESA / checkout transactions (paginated).
// params: page, limit, method ("mpesa"|"loyalty"), search, branchId, from, to
export const getMpesaTransactions = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/payments/transactions", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transactions:", error);
      return null;
    });
};

// Tenant-wide checkout-funnel totals (counts, collected, discount, points).
export const getMpesaSummary = (params = {}) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/payments/summary", {
      headers: {
        authToken: getToken().authT,
        authKey: getToken().authk,
      },
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching transactions summary:", error);
      return null;
    });
};

// ===== Branch Management (Super Admin) =====
const branchHeaders = () => ({
  authToken: getToken().authT,
  authKey: getToken().authk,
});

export const getBranchList = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/list", {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching branches:", error);
      return null;
    });
};

export const getBranchById = (id) => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/getById/" + id, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching branch:", error);
      return null;
    });
};

export const createBranch = (data) => {
  return axios
    .post(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/create", data, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error creating branch:", error);
      return error.response ? error.response.data : null;
    });
};

export const updateBranch = (id, data) => {
  return axios
    .put(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/update/" + id, data, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating branch:", error);
      return error.response ? error.response.data : null;
    });
};

export const toggleBranchStatus = (id) => {
  return axios
    .patch(
      process.env.REACT_APP_DEFAULTAUTH + "/api/branch/toggleStatus/" + id,
      {},
      { headers: branchHeaders() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error toggling branch status:", error);
      return error.response ? error.response.data : null;
    });
};

export const deleteBranch = (id) => {
  return axios
    .delete(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/delete/" + id, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error deleting branch:", error);
      return error.response ? error.response.data : null;
    });
};

export const updateBranchSettings = (id, data) => {
  return axios
    .put(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/settings/" + id, data, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating branch settings:", error);
      return error.response ? error.response.data : null;
    });
};

// Public active-branch list — used by catalog editors to pick branches for
// branch-scoping + price overrides (no auth required on the backend).
export const getActiveBranches = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/active")
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching active branches:", error);
      return null;
    });
};

// ============ MASTER CATALOG (branch pick-list + global discontinue) ============
// The hotel keeps ONE master catalog per tenant. An item lives there once and is
// carried by every branch by default; a branch that does not sell it records an
// exclusion. `isActive: false` withdraws an item from every branch at once.

// Every catalog type with its items. Pass a branchId to have each item report
// whether that branch currently carries it (this pre-ticks the pick-list).
export const getMasterCatalog = (branchId, includeInactive = false, countsOnly = false) => {
  const params = [];
  if (branchId) params.push(`branchId=${encodeURIComponent(branchId)}`);
  if (includeInactive) params.push("includeInactive=true");
  // countsOnly drops the item records and returns per-category tallies only -
  // used by the sidebar, which needs to know what a branch carries, not what.
  if (countsOnly) params.push("countsOnly=true");
  const qs = params.length ? `?${params.join("&")}` : "";
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/master-catalog" + qs, {
      headers: branchHeaders(),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching master catalog:", error);
      return null;
    });
};

// Re-apply a branch's pick-list. `selection` is { food: [ids], roomType: [ids], ... };
// the ids are the items the branch DOES carry. Types omitted are left untouched.
export const setBranchCatalogSelection = (branchId, selection) => {
  return axios
    .put(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/branch/master-catalog/selection/" +
        branchId,
      { selection },
      { headers: branchHeaders() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating branch catalog:", error);
      return null;
    });
};

// Global discontinue / reinstate across ALL branches.
export const setCatalogGlobalAvailability = (type, ids, isActive) => {
  return axios
    .patch(
      process.env.REACT_APP_DEFAULTAUTH + "/api/branch/master-catalog/availability",
      { type, ids, isActive },
      { headers: branchHeaders() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error updating catalog availability:", error);
      return null;
    });
};

// Full record for one catalog item, for the Master Catalog detail panel.
export const getMasterCatalogItem = (type, id) => {
  return axios
    .get(
      process.env.REACT_APP_DEFAULTAUTH +
        "/api/branch/master-catalog/item/" +
        encodeURIComponent(type) +
        "/" +
        encodeURIComponent(id),
      { headers: branchHeaders() }
    )
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching catalog item:", error);
      return null;
    });
};

// Provision a branch admin for an EXISTING branch — same emailed-credentials
// flow that branch creation offers inline.
export const addBranchAdmin = (branchId, data) => {
  return axios
    .post(
      process.env.REACT_APP_DEFAULTAUTH + "/api/branch/" + branchId + "/admin",
      data,
      { headers: branchHeaders() }
    )
    .then((response) => response.data)
    .catch((error) =>
      error.response ? error.response.data : null
    );
};

// Branch performance comparison — every branch side by side for one period.
// A branch admin is pinned server-side and simply gets their own row.
// Takes periodToParams() output, or a legacy "today" | "month" string.
export const getBranchComparison = (period = "month") => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/analytics/branch-comparison", {
      headers: branchHeaders(),
      params: typeof period === "string" ? { period } : period,
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Error fetching branch comparison:", error);
      return null;
    });
};

/**
 * Per-category counts for the CALLER'S own branch. Takes no branchId - the
 * server derives it - so any admin may call it, unlike getMasterCatalog which
 * is super-admin only. Used by the sidebar to hide what a branch does not sell.
 */
export const getMyCatalogCounts = () => {
  return axios
    .get(process.env.REACT_APP_DEFAULTAUTH + "/api/branch/my-catalog-counts", {
      headers: branchHeaders(),
    })
    .then((r) => r.data)
    .catch(() => null);
};

// ============ CROSS-SELL (CROSSSELL module) ============
// Rules are JSON with nested conditions / offer / schedule. A failure comes
// back as { status: 400, message } — the server's message is meant for the form.

const crossSellUrl = (path) => `${process.env.REACT_APP_DEFAULTAUTH}/api/crosssell${path}`;

export const getCrossSellRules = (params = {}) => {
  return axios
    .get(crossSellUrl("/rules"), { headers: branchHeaders(), params })
    .then((r) => r.data)
    .catch(() => null);
};

export const getCrossSellRule = (id) => {
  return axios
    .get(crossSellUrl(`/rules/${id}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const createCrossSellRule = (data) => {
  return axios
    .post(crossSellUrl("/rules"), data, { headers: { ...branchHeaders(), "Content-Type": "application/json" } })
    .then((r) => r.data)
    .catch(() => null);
};

export const updateCrossSellRule = (id, data) => {
  return axios
    .put(crossSellUrl(`/rules/${id}`), data, { headers: { ...branchHeaders(), "Content-Type": "application/json" } })
    .then((r) => r.data)
    .catch(() => null);
};

// `active` is optional: omitted, the server flips the current state.
export const toggleCrossSellRule = (id, active) => {
  return axios
    .patch(crossSellUrl(`/rules/${id}/toggle`), active === undefined ? {} : { active }, { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const deleteCrossSellRule = (id) => {
  return axios
    .delete(crossSellUrl(`/rules/${id}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

// `params` is periodToParams() output.
export const getCrossSellReport = (params = {}) => {
  return axios
    .get(crossSellUrl("/report"), { headers: branchHeaders(), params })
    .then((r) => r.data)
    .catch(() => null);
};

// ============ ROOM BOOKING: assign a room number ============
// An empty string clears it. Branch-guarded on the server.
export const assignRoomNumber = (roomBookingId, assignedRoomNumber) => {
  return axios
    .post(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/admin/assignRoomNumber`,
      { roomBookingId, assignedRoomNumber },
      { headers: branchHeaders() }
    )
    .then((r) => r.data)
    .catch(() => null);
};

// ============ OUTLETS: restaurants & bars (TABLE module) ============
// JSON bodies; PUT is partial (keys left out keep their value). A failure
// comes back as { success: false, message } for the form to show.

const outletUrl = (path = "") => `${process.env.REACT_APP_DEFAULTAUTH}/api/outlets${path}`;

export const getOutlets = () => {
  return axios
    .get(outletUrl(), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const getOutlet = (id) => {
  return axios
    .get(outletUrl(`/${id}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const createOutlet = (data) => {
  return axios
    .post(outletUrl(), data, { headers: { ...branchHeaders(), "Content-Type": "application/json" } })
    .then((r) => r.data)
    .catch(() => null);
};

export const updateOutlet = (id, data) => {
  return axios
    .put(outletUrl(`/${id}`), data, { headers: { ...branchHeaders(), "Content-Type": "application/json" } })
    .then((r) => r.data)
    .catch(() => null);
};

// `active` is optional: omitted, the server flips the current state.
export const toggleOutlet = (id, active) => {
  return axios
    .patch(outletUrl(`/${id}/toggle`), active === undefined ? {} : { active }, { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const deleteOutlet = (id) => {
  return axios
    .delete(outletUrl(`/${id}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

// The host-stand day view. `date` is YYYY-MM-DD; omitted, today in branch time.
export const getOutletDayBookings = (id, date) => {
  return axios
    .get(outletUrl(`/${id}/bookings`), { headers: branchHeaders(), params: date ? { date } : {} })
    .then((r) => r.data)
    .catch(() => null);
};

// ============ ROOM STOCK: numbered rooms + availability (ROOM module) ============
// Branch-scoped on the server. A global admin names the branch with `branchId`
// (query or body); otherwise the switcher's x-branch-id applies.

const roomStockUrl = (path) => `${process.env.REACT_APP_DEFAULTAUTH}/api/rooms${path}`;
const jsonHeaders = () => ({ ...branchHeaders(), "Content-Type": "application/json" });

export const getRoomUnits = (params = {}) => {
  return axios
    .get(roomStockUrl("/units"), { headers: branchHeaders(), params })
    .then((r) => r.data)
    .catch(() => null);
};

// `numbers` takes "101-110, 201, 2A" (ranges keep zero padding; up to 200).
export const createRoomUnits = (data) => {
  return axios
    .post(roomStockUrl("/units"), data, { headers: jsonHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const updateRoomUnit = (id, data) => {
  return axios
    .put(roomStockUrl(`/units/${id}`), data, { headers: jsonHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const deleteRoomUnit = (id) => {
  return axios
    .delete(roomStockUrl(`/units/${id}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

// Nights "YYYY-MM-DD", both included.
export const addRoomOutOfService = (id, data) => {
  return axios
    .post(roomStockUrl(`/units/${id}/out-of-service`), data, { headers: jsonHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

export const removeRoomOutOfService = (id, blockId) => {
  return axios
    .delete(roomStockUrl(`/units/${id}/out-of-service/${blockId}`), { headers: branchHeaders() })
    .then((r) => r.data)
    .catch(() => null);
};

// { branchId?, from: "YYYY-MM-DD", days (≤ 62) }
export const getRoomAvailability = (params = {}) => {
  return axios
    .get(roomStockUrl("/availability"), { headers: branchHeaders(), params })
    .then((r) => r.data)
    .catch(() => null);
};

// ============ OUTLET BOOKINGS: host-stand status ============
// confirmed | seated | completed | no_show | cancelled. no_show and cancelled free the covers.
export const setOutletBookingStatus = (bookingId, status, reason) => {
  return axios
    .patch(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/outlets/bookings/${bookingId}/status`,
      reason ? { status, reason } : { status },
      { headers: jsonHeaders() }
    )
    .then((r) => r.data)
    .catch(() => null);
};

// ============ FOOD ORDERS: hotel-side cancellation ============
// An undelivered order (typically after a failed delivery). Branch-scoped; the
// guest and the driver are told. `reason` is optional free text.
export const cancelFoodOrder = (foodorderId, reason) => {
  return axios
    .post(
      `${process.env.REACT_APP_DEFAULTAUTH}/api/admin/cancelFoodOrder`,
      reason ? { foodorderId, reason } : { foodorderId },
      { headers: jsonHeaders() }
    )
    .then((r) => r.data)
    .catch(() => null);
};
